import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-accordion-item',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="overflow-hidden rounded-sm bg-white shadow-sm">
      <button
        type="button"
        [id]="headerId()"
        class="hover:bg-blue-75 flex w-full cursor-pointer items-center justify-between gap-2 border border-white px-3 py-0 text-left transition-colors hover:border-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-inset md:px-4 md:py-3"
        [class.bg-blue-75/50]="expanded()"
        (click)="toggle.emit()"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="panelId()"
        [attr.aria-label]="ariaLabel()"
      >
        <div class="flex items-center gap-2 py-2">
          <ng-content select="[accordion-icon]"></ng-content>
          <span class="font-lato flex items-center">
            <ng-content select="[accordion-label]"></ng-content>
          </span>
        </div>
        <div class="font-lato text-brand-muted flex items-center text-sm">
          <ng-content select="[accordion-meta]"></ng-content>
          <mat-icon
            class="-mr-2 flex! h-8! w-8! items-center! justify-center! text-base! text-black"
            aria-hidden="true"
            >{{ expanded() ? 'expand_less' : 'chevron_right' }}</mat-icon
          >
        </div>
      </button>

      @if (expanded()) {
        <div [id]="panelId()" role="list" [attr.aria-labelledby]="headerId()">
          <ng-content></ng-content>
        </div>
      }
    </div>
  `,
})
export class AccordionItemComponent {
  readonly expanded = input.required<boolean>();

  readonly ariaLabel = input<string>('');

  readonly panelId = input<string>('');

  readonly headerId = input<string>('');

  readonly toggle = output<void>();
}
